export default __webpack_public_path__ + "static/media/sticker-A.fe15b9ed.png";